export const shop = {
  title: 'Shop AG1',
  category: 'Category',
  allProducts: 'All Products',
  gifts: 'Gifts',
  supplements: 'Supplements',
  subscriptions: 'Subscriptions',
  accessories: 'Accessories',
  gear: 'Gear',
  button: {
    addToCart: 'Add to Cart',
    addToNextOrder: 'Add to Next Order',
    subscribe: 'Subscribe',
    addedToNextOrder: 'Added to Next Order'
  },
  singleSubscription: 'Single Subscription',
  doubleSubscription: 'Double Subscription',
  description30: '30 Servings',
  description60: '60 Servings, best value',
  descriptionIndividual30: '30 Individual single servings',
  scoopAvailabilityInfo: '*Available to add to cart when at least one other product is in cart',
  scoopPrompt: 'Need a scoop with your pouch? Add it below for free.'
};
